import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../../molecules/RoundedModal'
import AddPurposeForm from './form'

const AddPurposeDialog = React.forwardRef(function AddPurposeDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false })

  const close = useCallback(() => {
    setDialogState({ open: false })
  }, [setDialogState])

  const handleComplete = useCallback((parsed) => {
    close()
    onComplete(parsed)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogState({ open: true })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Purpose'
      open={dialogState.open}
      onClose={close}
      size='lg'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <AddPurposeForm
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

AddPurposeDialog.propTypes = {
  onComplete: PropTypes.func
}

AddPurposeDialog.defaultProps = {
  onComplete: () => {}
}

export default AddPurposeDialog
